export default __webpack_public_path__ + "static/media/pipesProcess2.06e20d7a.png";